import { ConversionLogsTable } from "components/Tables/ConversionLogsTable/ConversionLogsTable.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { ConversionStateType, PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getLogHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/log/_layout/click/")({
    component: ClickLogsPage,
    staticData: {
        permissions: [PermissionEnum.ConversionClickLogView],
        showInSideMenu: false,
        label: "pages.log.click.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.log.click.title"),
        };
    },
});

function ClickLogsPage() {
    return (
        <TenantPage headerNavigationItems={getLogHeaderItems}>
            <ConversionLogsTable type={ConversionStateType.Click} />
        </TenantPage>
    );
}
